import type { ApiClient } from "@quotientjs/core"
import {
  AsyncStorageProvider,
  StorageProvider,
} from "@quotientjs/browser-storage"

import { People } from "./people"

export class Audience {
  public people: People

  constructor(
    apiClient: ApiClient,
    provider: StorageProvider | AsyncStorageProvider,
  ) {
    this.people = new People(apiClient, provider)
  }
}
